import { fetchFromAPI } from 'utils/api';

export const getFeedDeliveriesFarms = (params) => {
  return fetchFromAPI('/feed_deliveries/farms', { params });
};

export const getFeedDeliveriesFarmGroups = (farmId, params) => {
  return fetchFromAPI(`/feed_deliveries/farms/${farmId}/pig_groups`, { params });
};

// Unlike /farms/:id/bins, this endpoint lists ALL farm bins (manual ones included on FAS tenants)
export const getFeedDeliveriesBins = (farmId, params) => {
  return fetchFromAPI(`/feed_deliveries/farms/${farmId}/bins`, { params })
    .then((response) => response.resources);
};

export const getFeedDeliveriesRations = () => {
  return fetchFromAPI('/feed_deliveries/feed_rations').then((response) => response.resources);
};

export const createFeedDelivery = (farmId, resource) => {
  return fetchFromAPI(`/feed_deliveries/farms/${farmId}/deliveries`, {
    method: 'POST',
    body: JSON.stringify({ resource }),
  }).then((response) => response.resource);
};

export const updateFeedDelivery = (farmId, deliveryId, resource) => {
  return fetchFromAPI(`/feed_deliveries/farms/${farmId}/deliveries/${deliveryId}`, {
    method: 'PUT',
    body: JSON.stringify({ resource }),
  }).then((response) => response.resource);
};

export const deleteFeedDelivery = (farmId, deliveryId) => {
  return fetchFromAPI(`/feed_deliveries/farms/${farmId}/deliveries/${deliveryId}`, { method: 'DELETE' });
};

export const getBinCycles = (farmId, binId) => {
  return fetchFromAPI(`/feed_deliveries/farms/${farmId}/bins/${binId}/cycles`)
    .then((response) => response.resources);
};

export const openBinCycle = (farmId, binId, resource) => {
  return fetchFromAPI(`/feed_deliveries/farms/${farmId}/bins/${binId}/cycles`, {
    method: 'POST',
    body: JSON.stringify({ resource }),
  }).then((response) => response.resource);
};

export const closeBinCycle = (farmId, binId, cycleId, resource) => {
  return fetchFromAPI(`/feed_deliveries/farms/${farmId}/bins/${binId}/cycles/${cycleId}/close`, {
    method: 'PATCH',
    body: JSON.stringify({ resource }),
  }).then((response) => response.resource);
};

export const updateBinCycle = (farmId, binId, cycleId, resource) => {
  return fetchFromAPI(`/feed_deliveries/farms/${farmId}/bins/${binId}/cycles/${cycleId}`, {
    method: 'PUT',
    body: JSON.stringify({ resource }),
  }).then((response) => response.resource);
};

export const deleteBinCycle = (farmId, binId, cycleId) => {
  return fetchFromAPI(`/feed_deliveries/farms/${farmId}/bins/${binId}/cycles/${cycleId}`, { method: 'DELETE' });
};
